import {Component, Input, OnInit} from '@angular/core';
import {CompanyCategoryThresholdViewModel, CompanyCategoryType} from '../../../../../../services/api.client';
import {Observable} from 'rxjs';
import {CompanyCategoryService} from '../../../../../../services/companyCategory.service';
import {IPayeeCompanyCategoryAmount} from '../../../../../../shared/interfaces/IPayeeCompanyCategoryAmount';

@Component({
    selector: 'app-exceeds-category-amount-threshold',
    templateUrl: './exceeds-category-amount-threshold.component.html',
    styleUrls: ['./exceeds-category-amount-threshold.component.scss'],
    standalone: false
})
export class ExceedsCategoryAmountThresholdComponent implements OnInit {
    @Input() utilityTotal: number;
    @Input() rentalTotal: number;
    @Input() transportationTotal: number;
    @Input() childcareTotal: number;

    categoryThresholds: CompanyCategoryThresholdViewModel[];
    categoryThresholds$: Observable<CompanyCategoryThresholdViewModel[]>;

    currentPayeeCompanyCategoryAmounts$: Observable<IPayeeCompanyCategoryAmount[]>;

    utilityCompanyCategoryAmounts: IPayeeCompanyCategoryAmount[];
    rentalCompanyCategoryAmounts: IPayeeCompanyCategoryAmount[];
    transportationCompanyCategoryAmounts: IPayeeCompanyCategoryAmount[];
    childcareCompanyCategoryAmounts: IPayeeCompanyCategoryAmount[];
    carRepairCompanyCategoryAmounts: IPayeeCompanyCategoryAmount[];

    hasUtilityAmounts = false;
    hasRentalAmounts = false;
    hasTransportationAmounts = false;
    hasChildcareAmounts = false;
    hasCarRepairAmounts = false;

    utilityThresholdInformation: CompanyCategoryThresholdViewModel;
    rentalThresholdInformation: CompanyCategoryThresholdViewModel;
    transportationThresholdInformation: CompanyCategoryThresholdViewModel;
    childcareThresholdInformation: CompanyCategoryThresholdViewModel;
    carRepairThresholdInformation: CompanyCategoryThresholdViewModel;

    constructor(private _companyCategoryService: CompanyCategoryService) {
        this.categoryThresholds$ = this._companyCategoryService.categoryThresholds$;
        this.currentPayeeCompanyCategoryAmounts$ = this._companyCategoryService.currentPayeeCompanyCategoryAmounts$;
    }

    ngOnInit(): void {
        this.categoryThresholds$.subscribe(categoryThresholds => {
            this.categoryThresholds = categoryThresholds;
            this.setCompanyCategoryAmountsByCategory();
        });
    }

    private setThresholdInformation(): void {
        this.categoryThresholds.map(categoryThreshold => {
            switch (categoryThreshold.category.toString()) {
                case CompanyCategoryType.Utility:
                    this.utilityThresholdInformation = categoryThreshold;
                    break;
                case CompanyCategoryType.EmergencyRentalAssistance:
                    this.rentalThresholdInformation = categoryThreshold;
                    break;
                case CompanyCategoryType.TransportationForWorkforceNeeds:
                    this.transportationThresholdInformation = categoryThreshold;
                    break;
                case CompanyCategoryType.ChildcareSupport:
                    this.childcareThresholdInformation = categoryThreshold;
                    break;
                case CompanyCategoryType.CarRepair:
                    this.carRepairThresholdInformation = categoryThreshold;
                    break;
            }
        });
    }

    private setCompanyCategoryAmountsByCategory(): void {
        this.currentPayeeCompanyCategoryAmounts$.subscribe(payeeCompanyCategoryAmounts => {
            this.setThresholdInformation();
            this.utilityCompanyCategoryAmounts = payeeCompanyCategoryAmounts
                .filter(x => x.category === CompanyCategoryType.Utility);
            this.rentalCompanyCategoryAmounts = payeeCompanyCategoryAmounts
                .filter(x => x.category === CompanyCategoryType.EmergencyRentalAssistance);
            this.transportationCompanyCategoryAmounts = payeeCompanyCategoryAmounts
                .filter(x => x.category === CompanyCategoryType.TransportationForWorkforceNeeds);
            this.childcareCompanyCategoryAmounts = payeeCompanyCategoryAmounts
                .filter(x => x.category === CompanyCategoryType.ChildcareSupport);
            this.carRepairCompanyCategoryAmounts = payeeCompanyCategoryAmounts
                .filter(x => x.category === CompanyCategoryType.CarRepair);

            this.hasUtilityAmounts = this.utilityCompanyCategoryAmounts?.length > 0;
            this.hasRentalAmounts = this.rentalCompanyCategoryAmounts?.length > 0;
            this.hasTransportationAmounts = this.transportationCompanyCategoryAmounts?.length > 0;
            this.hasChildcareAmounts = this.childcareCompanyCategoryAmounts?.length > 0;
            this.hasCarRepairAmounts = this.carRepairCompanyCategoryAmounts?.length > 0;
        });
    }
}
